const tickerItems = [
  "男星L某 恋情实锤曝光",
  "头部主播A 货不对板回应",
  "选秀歌手S某 旧采访翻出",
  "导演W某 片场录音流出",
  "网红组合M 分成纠纷",
  "演员H某 代言连夜撤稿",
  "女团成员Z某 学历疑点",
  "综艺剪辑 双标质疑",
];

export default function HotTicker() {
  return (
    <section className="w-full overflow-hidden border-b border-background-200/70 bg-foreground-950">
      <div className="flex items-center">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 md:px-6">
          <span className="flex h-4 w-4 items-center justify-center text-background-50">
            <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
          </span>
          <span className="whitespace-nowrap text-xs font-semibold text-background-50 md:text-sm">
            实时热词滚动
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8 py-3 pl-6">
            {[...tickerItems, ...tickerItems].map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-background-200 md:text-sm"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}